import { styled, Tab as MaterialTab } from '@mui/material';

export interface TabProps {
  value: string;
  label: string | JSX.Element;
  disabled?: boolean;
  onClick?: () => void;
  style?: any;
}

export const Tab = styled((props: TabProps) => <MaterialTab {...props} />)(({}) => ({
  textTransform: 'none',
  fontStyle: 'normal',
  fontWeight: '400',
  width: '200px',
  fontSize: '15px',
  color: '#2C3D50',
  height: '54px',
  fontFamily: 'Poppins',
  '&.Mui-selected': {
    color: 'black',
  },
}));
